import React from 'react';
import BlobExplorer from './BlobExplorer';

function App() {
    return (
        <div className="App">
            <BlobExplorer />
        </div>
    );
}

export default App;
